import { render, staticRenderFns } from "./claimList.vue?vue&type=template&id=f34c39e2&scoped=true"
import script from "./claimList.vue?vue&type=script&lang=js"
export * from "./claimList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f34c39e2",
  null
  
)

export default component.exports